import adminUserList from "./admin-user-list/AdminUserList.vue";
import i18n from "../../i18n/index";
import userService from "../../services/users/userService";
import branchService from "../../services/branch/BranchService";
import serviceDocument from '../../services/patient/DocumentService'

export default {
    components: {
        adminUserList
    },
    data: () => ({
        dialog: false,
        hideList: false,
        branchData: [],
        none: { id: '', name: i18n.t('none') },
        user: {
            id: null,
            name: '',
            username: '',
            email: '',
            password: '',
            role: '',
            provider: '',
            branch: '',
            active: true,
            typeUser: '',
            identification: '',
            identificationType: ''
        },
        showIcon: false,
        showUpdate: false,
        showAdd: true,
        rules: [value => !!value || i18n.t('field-required')],
        emailRules: [
            v =>
                /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                i18n.t('email-must-be-valid')
        ],
        items: {
            providers: [],
            branches: [],
            roles: [],
            typeUsers: ["Externo","Interno"]
        },
        validForm: true,
        loadingSaveButton: false,
        loadingDelete: false
    }),
    created() {
        this.getRoles();
        this.getProviders();
    },
    mounted() {
        this.getDocumentTypes()       
      },
    methods: {
        getDocumentTypes() {
            serviceDocument.getDocuments().then(response => {
              this.documentTypeItems = response.data
            })
          },
        async handleUser(item) {
            console.log("x1",item)
            this.hideList = true;
            this.showIcon = false;
            this.user.id = item.id;
            this.user.name = item.name;
            this.user.username = item.username;
            this.user.email = item.email;
            this.user.password = '';
            this.user.role = item.idRole.id;
            this.user.provider = item.idBranch ? item.idBranch.idProvider.id : '';
            this.user.typeUser = item.userType,
            this.user.identification = item.identification,
            this.user.identificationType = item.idIdentificationType
            if (this.user.provider !== '') {
                await this.getBranches();
            } else {
                this.items.branches = [this.none]
            }
            this.user.branch = item.idBranch ? item.idBranch.id : '';

            this.user.active = item.active;
            this.showAdd = false;
            this.showUpdate = true;
        },
        closeUser() {
            this.hideList = false;
            this.dialog = false;
            this.showIcon = false;
            this.items.branches = [];
            // this.$refs.form.reset();
            this.user = {
                id: null,
                name: '',
                username: '',
                email: '',
                password: '',
                role: '',
                provider: '',
                branch: '',
                type: '',
                active: true,
                identification: ''
            };
            this.showAdd = true;
            this.showUpdate = false
        },
        getProviders() {
            return userService.getProviders().then(response => {
                this.items.providers = [this.none, ...response.data];
                this.items.branches = [this.none];
                this.user.branch = '';
            });
        },
        async getBranches() {
            const providerId = this.user.provider
            try {
                const response = await branchService.getBranchesByprovider(providerId)
                this.items.branches = [this.none, ...response.data]
                this.user.branch = ''
            } catch (error) {
               console.log(error) 
            }
        },
        getRoles() {
            userService.getRoles().then(response => {
                this.items.roles = response.data;
            });
        },
        save() {
            if (this.$refs.form.validate()) {
                if (this.user.password === '' || this.user.password === undefined){
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar una contraseña'
                    });
                    return
                }
                this.loadingSaveButton = true;
                this.showIcon = true;
                userService.createUser(this.user)
                    .then(value => {
                        this.loadingSaveButton = false;

                        if (value) {
                            this.$notify({
                                group: "app",
                                type: "success",
                                text: this.user.id ? i18n.t("user.succesfull-updated-user") : i18n.t("user.user-successfully-created")
                            });
                            this.$refs.adminUserList.searchUser();
                            this.closeUser();
                        }
                    }).catch(error => {
                        this.loadingSaveButton = false;
                        this.showIcon = false;

                        if (error && error.code) {
                            if (error.code == 'ALREADY_USERNAME') {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: i18n.t("user.username-already-taken")
                                });
                            } else if (error.code == 'ALREADY_EMAIL') {
                                this.$notify({
                                    group: "app",
                                    type: "error",
                                    text: i18n.t("user.email-already-taken")
                                });
                            }
                        }
                    });
            }
        },
        updateUser() {
            let UserId = this.user.id;
            let data = {
                email: this.user.email,
                name: this.user.name,
                password: this.user.password,
                idRole: this.user.role,
                active: this.user.active == true ? 1 : 0,
                username: this.user.username,
                idBranch: this.user.branch,
                userType: this.user.typeUser,
                identification: this.user.identification,
                idIdentificationType: this.user.identificationType
            };
            this.loadingSaveButton = true;
            this.showIcon = true;

            userService.updateUsers(UserId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 201) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Usuario Actualizado"
                    });
                    this.hideList = false;
                    this.$refs.adminUserList.searchUser();
                    this.closeUser();
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: error.code
                });
            });
        },
        deteleUser() {
            let data = { id: this.user.id };
            this.loadingDelete = true;
            userService.deleteUsers(data).then(result => {
                if (result.data === 'The User has associated transactions') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Usuario no pudo se eliminado, tiene Pedidos asociados."
                    });
                    this.hideList = false;
                    this.loadingDelete = false;
                    return;
                }
                if (result.status == 201) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Usuario Eliminado'
                    });
                    this.hideList = false;
                    this.loadingDelete = false;
                    this.$refs.adminUserList.searchUser();
                    this.closeUser();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: error
                });
            });
        },
        filterKeyCountDocument(e) {
            const key = e.key
            if(this.user.identificationType == 1 || this.user.identificationType == 7 || this.user.identificationType == 16 || this.user.identificationType == 8){
              if (/[0-9]/.test(key)) { } else { return e.preventDefault() }
            }      
          },
    }
};
